import _ from "lodash";
import { useEffect } from "react";
import Mark from "mark.js";

export const useHighlight = (sectionRef, id, searchString, onHighlightDone) => {
  useEffect(() => {
    const markInstance = new Mark(sectionRef.current);
    const shouldMark = !_.isEmpty(searchString);

    if (shouldMark) {
      markInstance.mark(searchString, {
        accuracy: "complementary",
        separateWordSearch: false,
        done: (amount) => onHighlightDone(id, amount),
      });
    }

    return () =>
      markInstance.unmark({
        done: () => onHighlightDone(id, 0),
      });
  }, [id, onHighlightDone, sectionRef, searchString]);
};
